import { useDispatch } from 'react-redux';
import { addNotification } from '../store/notification.slice';
import { getKey } from '../lib/util';
import { OptionsObject } from 'notistack';
import SnackbarAction from '../components/SnackbarAction';

const action = (id: string | number) => <SnackbarAction id={id} />;

const useNotification = () => {
  const dispatch = useDispatch();

  const initNotification = (message: string, options: OptionsObject): void => {
    dispatch(
      addNotification({
        key: getKey(),
        message,
        options,
      }),
    );
  };

  const successNotification = (message: string): void => {
    initNotification(message, { variant: 'success' });
  };

  const infoNotification = (message: string): void => {
    initNotification(message, { variant: 'info' });
  };

  const warningNotification = (message: string): void => {
    initNotification(message, { variant: 'warning' });
  };

  const errorNotification = (message: string): void => {
    initNotification(message, { variant: 'error', persist: true, action });
  };

  return {
    successNotification,
    infoNotification,
    warningNotification,
    errorNotification,
  };
};

export default useNotification;
